/* eslint-disable @leagueplatform/prefer-react-router-dom */
import { NavLink } from 'hooks/use-nav-links-list.hook';
// @ts-ignore
import { HashLink } from 'react-router-hash-link';
import { APP_NAV_DEFAULT_HEIGHT } from 'common/constants';
import { Box, styled } from '@leagueplatform/genesis-core';

// Determine if a link is a hash link
export const isHashLink = (link: NavLink['to']) => {
  if (typeof link === 'string') {
    return link.includes('#');
  }
  if (link instanceof Object) {
    return Boolean(link?.hash);
  }

  return false;
};

// Allow Hash to take Genesis props (css)
const GenesisCompatibleHashLink = styled(Box, {});

export const AppHashLink = ({
  children,
  ...restProps
}: {
  children: React.ReactNode;
}) => (
  <GenesisCompatibleHashLink
    as={HashLink}
    smooth
    scroll={(el: HTMLElement) => {
      // Scroll to the How can we help? heading on the Care Discovery landing page
      if (el.id === 'how-can-we-help') {
        const pageSectionHeadings = document.querySelectorAll('h2');
        const howCanWeHelpHeading = Array.from(pageSectionHeadings).find(
          (heading) => heading.textContent === 'How can we help?',
        );
        window.scrollTo({
          top: howCanWeHelpHeading?.offsetTop,
          behavior: 'smooth',
        });
        return;
      }

      const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
      const offset = yCoordinate - APP_NAV_DEFAULT_HEIGHT - 16;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...restProps}
  >
    {children}
  </GenesisCompatibleHashLink>
);
